import { useTranslation } from "react-i18next";

import { CommittedInput } from "@/components/committed-input";
import { Button } from "@/components/ui/button";

interface LookbackFieldProps {
  value: number | null;
  tenantDefault: number;
  onChange: (next: number | null) => void;
  disabled: boolean;
}

export function LookbackField({
  value,
  tenantDefault,
  onChange,
  disabled,
}: LookbackFieldProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-2">
      <span className="text-muted-foreground text-xs">
        {t("items.detail.lookback.label")}
      </span>
      <CommittedInput
        type="number"
        min={1}
        max={120}
        value={value === null ? "" : String(value)}
        placeholder={String(tenantDefault)}
        disabled={disabled}
        onCommit={(raw) => {
          const parsed = Number(raw);
          onChange(
            raw.trim() === "" || parsed === tenantDefault ? null : parsed,
          );
        }}
        className="h-7 w-16 text-xs"
      />
      <span className="text-muted-foreground text-xs">
        {t("items.detail.lookback.months")}
      </span>
      {value !== null && !disabled ? (
        <Button
          variant="link"
          size="sm"
          className="text-primary h-auto p-0 text-xs"
          onClick={() => onChange(null)}
        >
          {t("items.detail.lookback.reset")}
        </Button>
      ) : null}
    </div>
  );
}
